import React, { useLayoutEffect, useRef, useState } from 'react';
import './FeedbackPopup.css';

export default function FloatingSelectionFooter({ children }: any) {
  const footerRef = useRef<any>(null);
  const spacerRef = useRef<any>(null);
  const [height, setHeight] = useState<any>(0);
  const [left, setLeft] = useState(12);
  const [compact, setCompact] = useState<any>(false);

  useLayoutEffect(() => {
    const footer = footerRef.current;
    const parent = spacerRef.current.parentElement;
    const measure = () => {
      const contentLeft = Math.max(12, parent.getBoundingClientRect().left);
      setLeft(contentLeft);
      setCompact(window.innerWidth - contentLeft < 700);
      setHeight(footer.getBoundingClientRect().height);
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(footer);
    observer?.observe(parent);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return (
    <>
      <div ref={spacerRef} aria-hidden="true" style={{ height: height + (compact ? 104 : 36) }} />
      <footer ref={footerRef}
        className={`ae-selection-floating-footer${compact ? ' ae-selection-floating-footer-compact' : ''}`}
        style={{ left }}
        aria-label="Selected standards">
        <div className="ae-selection-footer-content">{children}</div>
      </footer>
    </>
  );
}
